module.exports = __webpack_public_path__ + "img/rio_grande_do_norte.dc6cf45c.jpg";